// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dac156e0","455":"743c45f0","488":"3df97650","977":"7b74b10d"}[chunkId] + ".chunk.js";
};